/* Hachiya sections · shared behaviour (no dependencies).
   Safe to include several times: it only boots once.
   Modules: [data-hy-carousel], [data-hy-gallery], [data-hy-plans] form, [data-hy-addon],
            [data-hy-more], [data-hy-scta], [data-hy-satc], [data-hy-hotspots], [data-hy-scroller]. */
(function () {
  if (window.Hachiya) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var behavior = reduce ? 'auto' : 'smooth';

  function each(root, sel, fn) {
    var list = root.querySelectorAll(sel);
    for (var i = 0; i < list.length; i++) fn(list[i]);
    if (root.matches && root.matches(sel)) fn(root);
  }
  function once(el, key) {
    if (el.dataset[key]) return false;
    el.dataset[key] = '1';
    return true;
  }
  function onScrollFrame(el, fn) {
    var raf;
    el.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(fn); }, { passive: true });
  }
  function footerEl() {
    return document.querySelector('.shopify-section-group-footer-group, footer, [data-hy-stop]');
  }

  /* ---------- Review carousel ---------- */
  function carousel(el) {
    if (!once(el, 'hyCarReady')) return;
    var track = el.querySelector('[data-hy-track]');
    var prev = el.querySelector('[data-hy-prev]');
    var next = el.querySelector('[data-hy-next]');
    if (!track) return;
    function step() {
      var slide = track.firstElementChild;
      if (!slide) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return slide.getBoundingClientRect().width + gap;
    }
    function maxScroll() { return track.scrollWidth - track.clientWidth - 2; }
    function update() {
      if (!prev || !next) return;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll();
    }
    function go(dir) { track.scrollBy({ left: dir * step(), behavior: behavior }); }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    onScrollFrame(track, update);
    window.addEventListener('resize', update);
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
    });
    update();

    if (el.dataset.autoplay === 'true' && !reduce) {
      var paused = false;
      var ms = parseInt(el.dataset.interval, 10) || 6000;
      var pause = function () { paused = true; };
      var resume = function () { paused = false; };
      el.addEventListener('mouseenter', pause);
      el.addEventListener('mouseleave', resume);
      el.addEventListener('focusin', pause);
      el.addEventListener('focusout', resume);
      track.addEventListener('touchstart', pause, { passive: true });
      setInterval(function () {
        if (paused || document.hidden || track.scrollWidth <= track.clientWidth) return;
        if (track.scrollLeft >= maxScroll()) track.scrollTo({ left: 0, behavior: behavior });
        else go(1);
      }, ms);
    }
  }

  /* ---------- Product gallery (swipe, dots, counter, thumbnails) ---------- */
  function gallery(el) {
    if (!once(el, 'hyGalReady')) return;
    var track = el.querySelector('[data-hy-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var thumbs = Array.prototype.slice.call(el.querySelectorAll('[data-hy-thumb]'));
    var dots = Array.prototype.slice.call(el.querySelectorAll('[data-hy-dot]'));
    var count = el.querySelector('[data-hy-count]');
    var last = -1;
    function index() { return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / Math.max(1, track.clientWidth)))); }
    function mark(i) {
      if (i === last) return;
      last = i;
      thumbs.forEach(function (t, n) { if (n === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      dots.forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
      if (count) count.textContent = String(i + 1);
    }
    function goTo(i, instant) {
      if (!slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: instant ? 'auto' : behavior });
      mark(i);
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goTo(parseInt(t.dataset.hyThumb, 10) || 0); });
    });
    onScrollFrame(track, function () { mark(index()); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(Math.min(slides.length - 1, index() + 1)); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(Math.max(0, index() - 1)); }
    });
    el.hyShowMedia = function (mediaId, instant) {
      if (!mediaId) return;
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].dataset.mediaId === String(mediaId)) { goTo(i, instant); return; }
      }
    };
    mark(0);
  }

  function showMedia(scope, mediaId, instant) {
    var g = scope && scope.querySelector('[data-hy-gallery]');
    if (g && g.hyShowMedia) g.hyShowMedia(mediaId, instant);
  }
  function setVariantUrl(id) {
    if (!id || !window.history || !history.replaceState) return;
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', id);
      history.replaceState(history.state, '', url.toString());
    } catch (e) {}
  }
  function setText(el, text) { if (el) { el.textContent = text || ''; } }
  function setOptional(el, text) { if (el) { el.textContent = text || ''; el.hidden = !text; } }

  /* Keep the sticky add-to-cart bar in step with the main form */
  function syncSatc(root, d) {
    var bar = root.querySelector('[data-hy-satc]');
    if (!bar) return;
    setText(bar.querySelector('[data-hy-satc-name]'), d.name);
    setText(bar.querySelector('[data-hy-satc-price]'), d.price);
    setOptional(bar.querySelector('[data-hy-satc-compare]'), d.compare);
    var b = bar.querySelector('[data-hy-satc-btn]');
    if (b) {
      b.disabled = !d.available;
      if (d.label) b.textContent = d.label;
    }
  }

  /* ---------- Plan picker (main soap product) ---------- */
  /* Slide-out cart: tell the theme's cart drawer what changed, then open it.
     If the drawer isn't on the page (or anything fails), fall back to the cart page. */
  /* Shopify's CDN rewrites dynamic imports in asset files, so load the theme's events module
     through a tiny inline module script and hand it back on window. */
  var eventsPromise = null;
  function loadEvents() {
    if (window.__hyEvents) return Promise.resolve(window.__hyEvents);
    if (eventsPromise) return eventsPromise;
    eventsPromise = new Promise(function (resolve, reject) {
      var timer = setTimeout(function () { reject(new Error('events timeout')); }, 4000);
      document.addEventListener('hy:events-ready', function () { clearTimeout(timer); resolve(window.__hyEvents); }, { once: true });
      var s = document.createElement('script');
      s.type = 'module';
      s.textContent = "import * as m from '@shopify/events'; window.__hyEvents = m; document.dispatchEvent(new Event('hy:events-ready'));";
      s.onerror = function () { clearTimeout(timer); reject(new Error('events load failed')); };
      document.head.appendChild(s);
    });
    return eventsPromise;
  }

  function openCartDrawer(source, items, sections) {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) { window.location.href = '/cart'; return Promise.resolve(); }
    return loadEvents().then(function (m) {
      var def = m.CartLinesUpdateEvent.createPromise();
      source.dispatchEvent(new m.CartLinesUpdateEvent({
        action: 'add', context: 'product',
        lines: items.map(function (it) { return { merchandiseId: String(it.id), quantity: it.quantity }; }),
        promise: def.promise
      }));
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); })
        .then(function (cart) {
          def.resolve({
            cart: m.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
            detail: { items: cart.items, source: 'hachiya-plan-picker', sourceId: 'hachiya-plan-picker', itemCount: cart.item_count, sections: sections, didError: false }
          });
          return new Promise(function (res) { setTimeout(res, 350); });
        }, function () { /* cart.js hiccup: still show the drawer from the add response */ })
        .then(function () {
          // Belt and braces: if the drawer didn't refresh or open itself, do it here.
          var inner = drawer.querySelector('.cart-drawer__inner');
          if (sections && sections['cart-drawer-section'] && inner && inner.classList.contains('cart-drawer--empty')) {
            var doc = new DOMParser().parseFromString(sections['cart-drawer-section'], 'text/html');
            var fresh = doc.querySelector('.cart-drawer__inner');
            if (fresh) inner.replaceWith(fresh);
          }
          if (typeof drawer.open === 'function' && !drawer.isOpen) drawer.open();
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
        });
    }).catch(function () {
      // Last try without the events module: swap in the fresh drawer HTML and open it.
      try {
        var html = sections && sections['cart-drawer-section'];
        var inner = drawer.querySelector('.cart-drawer__inner');
        var fresh = html && new DOMParser().parseFromString(html, 'text/html').querySelector('.cart-drawer__inner');
        if (inner && fresh && typeof drawer.open === 'function') {
          inner.replaceWith(fresh);
          drawer.open();
          return;
        }
      } catch (e) {}
      window.location.href = '/cart';
    });
  }

  function plans(form) {
    if (!once(form, 'hyPlansReady')) return;
    var root = form.closest('[data-hy-pp]') || document;
    var radios = root.querySelectorAll('input[type="radio"][name="id"]');
    var sp = form.querySelector('[data-hy-selling-plan]');
    var giftsInput = form.querySelector('[data-hy-gifts-input]');
    var btn = form.querySelector('[data-hy-submit]');
    var btnText = form.querySelector('[data-hy-btn-text]');
    var price = root.querySelector('[data-hy-price]');
    var compare = root.querySelector('[data-hy-compare]');
    var save = root.querySelector('[data-hy-save]');
    var note = root.querySelector('[data-hy-note]');
    var pill = root.querySelector('[data-hy-gift-line]');
    var chips = root.querySelectorAll('[data-hy-gift]');
    var qtyInput = form.querySelector('[data-hy-qty]');
    var cur = null;

    function money(c) { return '$' + (c / 100).toFixed(2); }
    function qty() { return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1); }
    function setQty(n) {
      n = Math.min(20, Math.max(1, n));
      if (qtyInput) qtyInput.value = n;
      each(root, '[data-hy-qty-val]', function (o) { o.textContent = n; });
      if (cur && cur.dataset.once === 'true' && btnText) {
        var base = (cur.dataset.button || '').split(' · ')[0];
        var cents = (parseInt(cur.dataset.priceCents, 10) || 0) * n;
        btnText.textContent = base + ' · ' + money(cents);
        setText(price, money(cents));
      }
    }
    each(root, '[data-hy-qty-step]', function (b) {
      b.addEventListener('click', function () { setQty(qty() + parseInt(b.dataset.hyQtyStep, 10)); });
    });

    function apply(r, first) {
      var d = r.dataset;
      cur = r;
      if (sp) {
        if (d.sellingPlan) { sp.value = d.sellingPlan; sp.disabled = false; }
        else { sp.value = ''; sp.disabled = true; }
      }
      if (giftsInput) { giftsInput.value = d.giftsText || ''; giftsInput.disabled = !d.giftsText; }
      var on = (d.gifts || '').split(',').filter(Boolean);
      for (var i = 0; i < chips.length; i++) {
        var c = chips[i];
        var isOn = on.indexOf(c.dataset.hyGift) > -1;
        c.classList.toggle('is-on', isOn);
        var tag = c.querySelector('[data-hy-gift-tag]');
        if (tag) tag.textContent = isOn ? c.dataset.onLabel : c.dataset.offLabel;
      }
      setOptional(pill, d.giftLine);
      setText(price, d.price);
      setOptional(compare, d.compare);
      setOptional(save, d.save);
      setOptional(note, d.note);
      setText(btnText, d.button);
      var ok = d.available === 'true';
      if (btn) btn.disabled = !ok;
      syncSatc(root, { name: d.label, price: d.price, compare: d.compare, available: ok });
      if (!first) { setVariantUrl(r.value); showMedia(root, d.mediaId); }
      setQty(d.once === 'true' ? qty() : 1);
    }

    /* Add to cart: the plan (or single bars) plus that plan's free gifts in one go.
       A new plan replaces any plan and gifts already in the cart, so nobody ends up with two plans by accident. */
    var busy = false;
    form.addEventListener('submit', function (e) {
      if (!window.fetch || !cur) return;
      e.preventDefault();
      if (busy) return;
      busy = true;
      if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
      var d = cur.dataset;
      var line = { id: parseInt(cur.value, 10), quantity: d.once === 'true' ? qty() : 1, properties: {} };
      if (d.sellingPlan) line.selling_plan = parseInt(d.sellingPlan, 10);
      if (d.giftsText) line.properties._Gifts = d.giftsText;
      // Gifts first, plan last: the cart lists the newest line on top, so the plan shows above its gifts.
      var items = [];
      (d.giftIds || '').split(',').filter(Boolean).forEach(function (gid) {
        items.push({ id: parseInt(gid, 10), quantity: 1, properties: { 'Free gift': 'Included with your plan', _hy_gift: '1' } });
      });
      items.push(line);
      var isPlan = !!d.sellingPlan || items.length > 1;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : { items: [] }; }, function () { return { items: [] }; })
        .then(function (cart) {
          var updates = {}, n = 0;
          (cart.items || []).forEach(function (it) {
            var gift = it.properties && it.properties._hy_gift;
            var planLine = isPlan && /^HY-SOAP-(3|6|9)$/.test(it.sku || '');
            if (gift && isPlan || planLine) { updates[it.key] = 0; n++; }
          });
          if (!n) return null;
          return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates }) });
        })
        .then(function () {
          var ids = [];
          document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (c) { ids.push(c.dataset.sectionId); });
          return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items, sections: ids.join(',') }) });
        })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function (resp) {
          return openCartDrawer(form, items, resp && resp.sections);
        })
        .then(function () {
          busy = false;
          if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
        })
        .catch(function () {
          busy = false;
          if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
          HTMLFormElement.prototype.submit.call(form);
        });
    });
    for (var i = 0; i < radios.length; i++) {
      radios[i].addEventListener('change', function (e) { if (e.target.checked) apply(e.target, false); });
    }
    var checked = root.querySelector('input[type="radio"][name="id"]:checked');
    if (checked) { apply(checked, true); }
  }

  /* ---------- Add-on product ---------- */
  function addon(el) {
    if (!once(el, 'hyAddonReady')) return;
    var form = el.querySelector('[data-hy-addon-form]');
    if (!form) return;
    var select = form.querySelector('[data-hy-variant]');
    var qty = form.querySelector('input[name="quantity"]');
    var btn = form.querySelector('[data-hy-submit]');
    var btnText = form.querySelector('[data-hy-btn-text]');
    var price = el.querySelector('[data-hy-price]');
    var compare = el.querySelector('[data-hy-compare]');
    var compareAmt = el.querySelector('[data-hy-compare-amt]');
    var save = el.querySelector('[data-hy-save]');
    var title = el.querySelector('.hy-ad__title');

    each(form, '[data-hy-qty-step]', function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(qty.value, 10) || 1;
        var min = parseInt(qty.min, 10) || 1;
        var max = parseInt(qty.max, 10) || 99;
        v = Math.min(max, Math.max(min, v + parseInt(b.dataset.hyQtyStep, 10)));
        qty.value = v;
        qty.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    if (select) {
      select.addEventListener('change', function () {
        var o = select.options[select.selectedIndex];
        if (!o) return;
        var d = o.dataset;
        setText(price, d.price);
        setText(compareAmt, d.compare);
        if (compare) compare.hidden = !d.compare;
        if (save) { if (d.save) save.textContent = d.save; save.hidden = !d.compare; }
        var ok = d.available === 'true';
        if (btn) btn.disabled = !ok;
        if (btnText && btn) btnText.textContent = ok ? btn.dataset.label : btn.dataset.soldOut;
        syncSatc(el, {
          name: (title ? title.textContent.trim() + ' · ' : '') + (d.label || ''),
          price: d.price, compare: d.compare, available: ok,
          label: btn ? (ok ? btn.dataset.label : btn.dataset.soldOut) : ''
        });
        setVariantUrl(o.value);
        showMedia(el, d.mediaId);
      });
    }
  }

  /* ---------- Read more (phones) ---------- */
  var phone = window.matchMedia ? window.matchMedia('(max-width: 767px)') : null;
  function more(el) {
    if (!once(el, 'hyMoreReady')) return;
    var body = el.querySelector('.hy-more__body');
    var btn = el.querySelector('.hy-more__btn');
    if (!body || !btn) return;
    var label = btn.querySelector('[data-hy-more-label]') || btn;
    // Text that already fits needs no clamp (checked once, on phones only).
    if (phone && phone.matches && body.scrollHeight <= body.clientHeight + 4) {
      el.classList.remove('hy-more--clamp');
      return;
    }
    btn.addEventListener('click', function () {
      var open = el.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      label.textContent = open ? btn.dataset.less : btn.dataset.more;
    });
  }

  /* ---------- Bottom bars: shared show/hide ---------- */
  /* Shown once watchEl has scrolled fully above the viewport; hidden while the footer is on screen.
     Uses one rAF-throttled scroll check (robust to fast jumps, unlike threshold-only observers). */
  function bottomBar(bar, watchEl, pastFallback) {
    var focusables = bar.querySelectorAll('a, button');
    var foot = footerEl();
    var state = null, raf;
    function check() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var past = watchEl ? watchEl.getBoundingClientRect().bottom < 0 : window.pageYOffset > pastFallback;
      var footVis = foot ? foot.getBoundingClientRect().top < vh : false;
      var on = past && !footVis;
      if (on === state) return;
      state = on;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      for (var i = 0; i < focusables.length; i++) focusables[i].tabIndex = on ? 0 : -1;
    }
    function queue() { cancelAnimationFrame(raf); raf = requestAnimationFrame(check); }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    check();
  }

  /* ---------- Sticky CTA (home / pages, phones) ---------- */
  function scta(bar) {
    if (!once(bar, 'hyScta')) return;
    bottomBar(bar, document.querySelector('[data-hy-hero]'), 600);
  }

  /* ---------- Sticky add to cart (product pages, phones) ---------- */
  function satc(bar) {
    if (!once(bar, 'hySatc')) return;
    var root = bar.closest('[data-hy-pp], [data-hy-addon]') || document;
    var main = root.querySelector('[data-hy-submit]');
    var btn = bar.querySelector('[data-hy-satc-btn]');
    bottomBar(bar, main, 900);
    if (btn) {
      btn.addEventListener('click', function (e) {
        // Browsers without the form attribute: scroll to the picker instead.
        if (btn.form) return;
        e.preventDefault();
        var t = bar.dataset.target && document.querySelector(bar.dataset.target);
        if (t) t.scrollIntoView({ behavior: behavior, block: 'start' });
      });
    }
  }

  /* ---------- Hotspots ---------- */
  function hotspots(el) {
    if (!once(el, 'hyHsReady')) return;
    var pins = el.querySelectorAll('[data-hy-pin]');
    var items = el.querySelectorAll('[data-hy-spot]');
    function set(n) {
      for (var i = 0; i < pins.length; i++) pins[i].classList.toggle('is-active', pins[i].dataset.hyPin === n);
      for (var j = 0; j < items.length; j++) items[j].classList.toggle('is-active', items[j].dataset.hySpot === n);
    }
    each(el, '[data-hy-pin]', function (p) {
      p.addEventListener('click', function () {
        set(p.dataset.hyPin);
        var item = el.querySelector('[data-hy-spot="' + p.dataset.hyPin + '"]');
        if (item && item.scrollIntoView) item.scrollIntoView({ behavior: behavior, block: 'nearest' });
      });
    });
    each(el, '[data-hy-spot]', function (it) {
      it.addEventListener('mouseenter', function () { set(it.dataset.hySpot); });
    });
  }

  /* ---------- Scroller dots ---------- */
  function scroller(el) {
    if (!once(el, 'hyScReady')) return;
    var track = el.querySelector('[data-hy-track]');
    var dots = el.querySelectorAll('[data-hy-dot]');
    if (!track || !dots.length) return;
    onScrollFrame(track, function () {
      var first = track.firstElementChild;
      if (!first) return;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var w = first.getBoundingClientRect().width + gap;
      var i = Math.round(track.scrollLeft / Math.max(1, w));
      if (track.scrollLeft >= track.scrollWidth - track.clientWidth - 2) i = dots.length - 1;
      for (var n = 0; n < dots.length; n++) dots[n].classList.toggle('is-on', n === i);
    });
  }

  function init(root) {
    root = root || document;
    each(root, '[data-hy-carousel]', carousel);
    each(root, '[data-hy-gallery]', gallery);
    each(root, '[data-hy-plans]', plans);
    each(root, '[data-hy-addon]', addon);
    each(root, '[data-hy-more]', more);
    each(root, '[data-hy-scta]', scta);
    each(root, '[data-hy-satc]', satc);
    each(root, '[data-hy-hotspots]', hotspots);
    each(root, '[data-hy-scroller]', scroller);
  }

  window.Hachiya = { init: init, cartUpdate: openCartDrawer };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
